import { Component, effect, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { LaddaModule } from "angular2-ladda";
import { RecaptchaModule } from "ng-recaptcha";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import {
  API_URLS,
  DECIMAL_NUMBER_PATTERN,
  EMAIL_PATTERN,
  WHOLE_NUMBER_PATTERN,
} from "../../../config/app.constants";
import { OutPostModalService } from "../../../shared/header/outpost-list-modal/out-post-modal.service";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";

declare var $: any;

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    NgSelectModule,
    LaddaModule,
    RecaptchaModule,
  ],
})
export class ContactUsComponent implements OnInit {
  @ViewChild("recaptchaRef") recaptchaRef;
  plans: any[];
  submitted: boolean = false;
  isCaptchaValid = false;
  isSubmit: boolean = false;
  reCaptchaSiteKey;

  contactUsForm: FormGroup;
  name = new FormControl("", [Validators.required]);
  email = new FormControl("", [
    Validators.required,
    Validators.pattern(EMAIL_PATTERN),
  ]);
  phone_no = new FormControl("", [
    Validators.pattern(WHOLE_NUMBER_PATTERN),
    Validators.minLength(6),
    Validators.maxLength(15),
  ]);
  pet_breed = new FormControl("", []);
  pet_name = new FormControl("", []);
  pet_age = new FormControl("", [Validators.pattern(DECIMAL_NUMBER_PATTERN)]);
  pet_subscription_plan = new FormControl(undefined, []);
  message = new FormControl("", [Validators.required]);
  user_id = new FormControl("", []);
  selectedOutpostId;
  currentOutpostId;

  constructor(
    private http: HttpinterceptorService,
    private formBuilder: FormBuilder,
    private outpostModalService: OutPostModalService
  ) {
    // this.currentOutpostId = this.outpostModalService.currentPlan.subscribe(
    //   (el: any) => {
    //     if (localStorage.getItem("selectedOutpostId")) {
    //       this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //     }
    //   }
    // );

    effect(() => {
      const el = this.outpostModalService.activatedPlan();
      if (localStorage.getItem("selectedOutpostId")) {
        this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
      }
    });

    this.getPearlandStatus();
  }

  ngOnInit() {
    this.InitializeForm();
    this.getPlans();
  }
  // ngOnDestroy(): void {
  //   //Called once, before the instance is destroyed.
  //   //Add 'implements OnDestroy' to the class.
  //   if (this.currentOutpostId) {
  //     this.currentOutpostId.unsubscribe();
  //   }
  // }
  InitializeForm() {
    this.contactUsForm = this.formBuilder.group({
      name: this.name,
      email: this.email,
      phone_no: this.phone_no,
      pet_breed: this.pet_breed,
      pet_name: this.pet_name,
      pet_age: this.pet_age,
      pet_subscription_plan: this.pet_subscription_plan,
      message: this.message,
      user_id: this.user_id,
      out_post_id: this.selectedOutpostId,
    });
  }

  submitContactDetail() {
    this.submitted = true;

    if (this.contactUsForm.valid && this.isCaptchaValid) {
      this.contactUsForm.value["out_post_id"] = this.selectedOutpostId;
      this.isSubmit = true;
      this.http
        .post(API_URLS.CONTACT_US_SUBMIT, this.contactUsForm.value, true)
        .subscribe(
          (response) => {
            if (response.code === 200 && response.type === "success") {
              this.submitted = false;
              this.isCaptchaValid = false;
              this.isSubmit = false;
              this.contactUsForm.reset();
              this.recaptchaRef.reset();
            } else {
              this.isSubmit = false;
            }
          },
          (error) => {
            this.isSubmit = false;
          }
        );
    } else {
      return false;
    }
  }

  getPlans() {
    this.http.post(API_URLS.GET_PLANS, {}, false).subscribe((response) => {
      if (response.type === "success") {
        if (response.data) {
          this.plans = response.data;
        }
      }
    });
  }

  getPearlandStatus() {
    this.http.post(API_URLS.SHOW_CONFIGURATION, {}, false).subscribe(
      (response) => {
        if (response.code === 200 && response.type === "success") {
          this.reCaptchaSiteKey = response.pearland_status.google_captcha;
        }
      },
      (error) => {}
    );
  }

  submitCaptcha(response) {
    if (response) {
      this.isCaptchaValid = true;
    }
  }
  gotToMap(address) {
    this.getLatLongFromAddress(address);
  }
  async getLatLongFromAddress(address: string): Promise<void> {
    const results = await this.getLatLong(address);
    if (results?.length) {
      const location = results[0].geometry?.location;

      const latlong = {
        lat: location.lat(),
        lng: location.lng(),
      };

      window.open(
        `https://www.google.com/maps?q=${latlong?.lat},${latlong?.lng}`,
        "_blank"
      );
    }
  }

  getLatLong(address: string): Promise<google.maps.GeocoderResult[]> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          resolve(results);
        } else {
          reject(status);
        }
      });
    });
  }
}
